export default __webpack_public_path__ + "static/media/prothetik_02.c2f52d1a.png";